import { useState } from "react";
import { toast } from "react-toastify";
import { deleteAppVersion } from "../../actions";

export const useDeleteAppVersionHook = ({
   selectedAppVersionData = {},
   handleSubmit = () => { },
}) => {
   const [isLoading, setIsLoading] = useState(false);

   const handleDeleteAppVersion = async () => {
      try {
         setIsLoading(true)

         const appVersionStatusRes = await deleteAppVersion(selectedAppVersionData.version_id)
         toast.success("App Version status updated.")
         handleSubmit()
      } catch (error) {
         console.log(error);
      } finally {
         setIsLoading(false)
      }
   }

   return {
      isLoading,
      handleDeleteAppVersion
   }
} 